<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 class="row">{{ "load-chainage.title" | translate }}</h2>
  <div *ngIf="topMenuIcons.length > 0">
    <button mat-raised-button [disabled]="
          !this.detailForm.valid ||
          this.disableByProfile"
           (click)="save()">
      <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
    </button>
    <button mat-raised-button *ngIf="!this.copy" [disabled]="this.disableByProfile" (click)="copyItem()">
      <mat-icon [title]="this.copyIconTitle"> content_copy </mat-icon>
    </button>
    <button mat-raised-button *ngIf="this.id !== 'new' && !this.copy" [disabled]="this.disableByProfile" (click)="deleteConfirm()">
      <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
    </button>
    <ng-container *ngFor="let action of topMenuIcons">
      <button mat-raised-button *ngIf="!action.hide" [routerLink]="action.routerLink"
        (click)="this[action.clickMethod]()" >
        <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
      </button>
    </ng-container>
  </div>
</div>
<form [formGroup]="detailForm">
  <div fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap="40px">
      <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label> {{ "load-chainage.id" | translate }} </mat-label>
        <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 180
            }" formControlName="id" />
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('chainage')" [ngStyle]="{
            'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.chainage" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
              'min-width.px': 180
            }" formControlName="chainage" [step]="countDecimalPlaces(detailForm.controls['chainage'].value)"/>
        <mat-error *ngIf="detailForm.controls['chainage'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['chainage'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <div style="margin-top: 15px;" [hidden]="this.id === 'new'">
        <button mat-raised-button (click)="this.recalculateSections()" [disabled]="this.id === 'new' || this.disableByProfile">
            {{ "load-chainage.button-recalculate-all" | translate }}
        </button>
        <button
        mat-raised-button
        [disabled]="
        !this.detailForm.valid ||
        this.disableByProfile"
        (click)="showPopupQueue()"
      >
      <mat-icon [title]="this.queueTitle"> queue </mat-icon>
      </button>
      </div>

      <mat-form-field *ngIf="columnsVisible.get('loadPoint')" [ngStyle]="{
            'width.ch': detailForm.controls['loadPoint'].value ? detailForm.controls['loadPoint'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.load_point" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['loadPoint'].value ? detailForm.controls['loadPoint'].value.length : 10,
              'min-width.px': 180
            }" formControlName="loadPoint" [step]="countDecimalPlaces(detailForm.controls['loadPoint'].value)"/>
        <mat-error *ngIf="detailForm.controls['loadPoint'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['loadPoint'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('load')" [ngStyle]="{
            'width.ch': detailForm.controls['load'].value ? detailForm.controls['load'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.load" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['load'].value ? detailForm.controls['load'].value.length : 10,
              'min-width.px': 180
            }" formControlName="load" [step]="countDecimalPlaces(detailForm.controls['load'].value)"/>
        <mat-error *ngIf="detailForm.controls['load'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['load'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('kDistSoil')" [ngStyle]="{
            'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.kDist-soil" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
              'min-width.px': 180
            }" formControlName="kDistSoil" [step]="countDecimalPlaces(detailForm.controls['kDistSoil'].value)"/>
        <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('kSubSoil')" [ngStyle]="{
            'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.kSub-soil" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
              'min-width.px': 180
            }" formControlName="kSubSoil"  [step]="countDecimalPlaces(detailForm.controls['kSubSoil'].value)" />
        <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>


      <mat-form-field *ngIf="columnsVisible.get('avgNormalStress')" [ngStyle]="{
              'width.ch': detailForm.controls['avgNormalStress'].value ? detailForm.controls['avgNormalStress'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.avg-normal-stress" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['avgNormalStress'].value ? detailForm.controls['avgNormalStress'].value.length : 10,
                'min-width.px': 180
              }" formControlName="avgNormalStress"
          [step]="countDecimalPlaces(detailForm.controls['avgNormalStress'].value)" />
        <mat-error *ngIf="detailForm.controls['avgNormalStress'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['avgNormalStress'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('maxOneFieldLimit')" [ngStyle]="{
              'width.ch': detailForm.controls['maxOneFieldLimit'].value ? detailForm.controls['maxOneFieldLimit'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.max-one-field-limit" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['maxOneFieldLimit'].value ? detailForm.controls['maxOneFieldLimit'].value.length : 10,
                'min-width.px': 180
              }" formControlName="maxOneFieldLimit" [step]="countDecimalPlaces(detailForm.controls['maxOneFieldLimit'].value)" />
        <mat-error *ngIf="detailForm.controls['maxOneFieldLimit'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['maxOneFieldLimit'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('maxOverallLimit')" [ngStyle]="{
              'width.ch': detailForm.controls['maxOverallLimit'].value ? detailForm.controls['maxOverallLimit'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.max-overall-limit" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['maxOverallLimit'].value ? detailForm.controls['maxOverallLimit'].value.length : 10,
                'min-width.px': 180
              }" formControlName="maxOverallLimit"
          [step]="countDecimalPlaces(detailForm.controls['maxOverallLimit'].value)" />
        <mat-error *ngIf="detailForm.controls['maxOverallLimit'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['maxOverallLimit'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('maxOverallOneFieldLimit')" [ngStyle]="{
              'width.ch': detailForm.controls['maxOverallOneFieldLimit'].value ? detailForm.controls['maxOverallOneFieldLimit'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.max-overall-one-field-limit" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['maxOverallOneFieldLimit'].value ? detailForm.controls['maxOverallOneFieldLimit'].value.length : 10,
                'min-width.px': 180
              }" formControlName="maxOverallOneFieldLimit"
          [step]="countDecimalPlaces(detailForm.controls['maxOverallOneFieldLimit'].value)" />
        <mat-error *ngIf="detailForm.controls['maxOverallOneFieldLimit'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['maxOverallOneFieldLimit'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('maxOverallTriangleLimit')" [ngStyle]="{
              'width.ch': detailForm.controls['maxOverallTriangleLimit'].value ? detailForm.controls['maxOverallTriangleLimit'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.max-overall-triangle-limit" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['maxOverallTriangleLimit'].value ? detailForm.controls['maxOverallTriangleLimit'].value.length : 10,
                'min-width.px': 180
              }" formControlName="maxOverallTriangleLimit"
          [step]="countDecimalPlaces(detailForm.controls['maxOverallTriangleLimit'].value)" />
        <mat-error *ngIf="detailForm.controls['maxOverallTriangleLimit'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['maxOverallTriangleLimit'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="40px">

      <mat-form-field *ngIf="columnsVisible.get('gravelSpacing')" [ngStyle]="{
              'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "load-chainage.gravel-spacing" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
                'min-width.px': 180
              }" formControlName="gravelSpacing" [step]="countDecimalPlaces(detailForm.controls['gravelSpacing'].value)" />
        <mat-error *ngIf="detailForm.controls['gravelSpacing'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['gravelSpacing'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('gravelStartPosition')" [ngStyle]="{
            'width.ch': detailForm.controls['gravelStartPosition'].value ? detailForm.controls['gravelStartPosition'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "load-chainage.gravel-start-position" | translate }}</mat-label>
        <input matInput type="number" class="form-control"
          [step]="countDecimalPlaces(detailForm.controls['gravelStartPosition'].value)" [ngStyle]="{
      'width.ch': detailForm.controls['gravelStartPosition'].value ? detailForm.controls['gravelStartPosition'].value.length : 10,
      'min-width.px': 180
    }" formControlName="gravelStartPosition" />
        <mat-error *ngIf="detailForm.controls['gravelStartPosition'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['gravelStartPosition'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>


      <mat-form-field *ngIf="columnsVisible.get('gravelDiffOptimalThick')" [ngStyle]="{
        'width.ch': detailForm.controls['gravelDiffOptimalThick'].value ? detailForm.controls['gravelDiffOptimalThick'].value.length : 10,
        'min-width.px': 200
      }">
    <mat-label>{{ "load-chainage.gravel-diff-optimal-thick" | translate }}</mat-label>
    <input matInput type="number" class="form-control" [ngStyle]="{
          'width.ch': detailForm.controls['gravelDiffOptimalThick'].value ? detailForm.controls['gravelDiffOptimalThick'].value.length : 10,
          'min-width.px': 180
        }" formControlName="gravelDiffOptimalThick" [step]="countDecimalPlaces(detailForm.controls['gravelDiffOptimalThick'].value)"/>
    <mat-error *ngIf="detailForm.controls['gravelDiffOptimalThick'].errors?.['required']">
      {{ "error.required" | translate }}
    </mat-error>
    <mat-error *ngIf="detailForm.controls['gravelDiffOptimalThick'].errors?.['pattern']">{{ "error.number_pattern" |
      translate }}</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="columnsVisible.get('baseSurveyDiff')" [ngStyle]="{
      'width.ch': detailForm.controls['baseSurveyDiff'].value ? detailForm.controls['baseSurveyDiff'].value.length : 10,
      'min-width.px': 200
    }">
    <mat-label>{{ "load-chainage.base-survey-diff" | translate }}</mat-label>
    <input matInput type="number" class="form-control" [ngStyle]="{
        'width.ch': detailForm.controls['baseSurveyDiff'].value ? detailForm.controls['baseSurveyDiff'].value.length : 10,
        'min-width.px': 180
      }" formControlName="baseSurveyDiff"
      [step]="countDecimalPlaces(detailForm.controls['baseSurveyDiff'].value)" />
    <mat-error *ngIf="detailForm.controls['baseSurveyDiff'].errors?.['required']">
      {{ "error.required" | translate }}
    </mat-error>
    <mat-error *ngIf="detailForm.controls['baseSurveyDiff'].errors?.['pattern']">{{ "error.number_pattern" |
      translate }}</mat-error>
  </mat-form-field>


  <mat-form-field *ngIf="columnsVisible.get('bermHeightTarget')" [ngStyle]="{
    'width.ch': detailForm.controls['bermHeightTarget'].value ? detailForm.controls['bermHeightTarget'].value.length : 10,
    'min-width.px': 200
  }">
  <mat-label>{{ "load-chainage.berm-height-target" | translate }}</mat-label>
  <input matInput type="number" class="form-control" [ngStyle]="{
      'width.ch': detailForm.controls['bermHeightTarget'].value ? detailForm.controls['bermHeightTarget'].value.length : 10,
      'min-width.px': 180
    }" formControlName="bermHeightTarget"
    [step]="countDecimalPlaces(detailForm.controls['bermHeightTarget'].value)" />
  <mat-error *ngIf="detailForm.controls['bermHeightTarget'].errors?.['required']">
    {{ "error.required" | translate }}
  </mat-error>
  <mat-error *ngIf="detailForm.controls['bermHeightTarget'].errors?.['pattern']">{{ "error.number_pattern" |
    translate }}</mat-error>
</mat-form-field>


        <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('gravelCalc_disabled')" [ngStyle]="{
          'width.ch': detailForm.controls['gravelCalc_disabled'].value ? detailForm.controls['gravelCalc_disabled'].value.length : 10,
          'min-width.px': 200
       }">
           <mat-label>{{ "load-chainage.gravel-calc" | translate }}</mat-label>
           <input matInput [disabled]="true" [ngStyle]="{
           'width.ch': detailForm.controls['gravelCalc_disabled'].value ? detailForm.controls['gravelCalc_disabled'].value.length : 10,
           'min-width.px': 180
       }" formControlName="gravelCalc_disabled" />
         </mat-form-field>

      <app-gravel-calc-type-dropdown *ngIf="columnsVisible.get('gravelCalc')"
        (selectedChange)="this.setSelectedTypeGravelCalc($event)" [required]="true" [singleSelection]="true"
        [selected]="this.preSelectedTypeGravelCalc">
      </app-gravel-calc-type-dropdown>

      <mat-form-field
      *ngIf="columnsVisible.get('name')"
      [ngStyle]="{
        'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
        'min-width.px': 420
      }"
    >
      <mat-label>{{ "load-chainage.name" | translate }}</mat-label>
      <input
        matInput
        class="form-control"
        [ngStyle]="{
          'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
          'min-width.px': 400
        }"
        formControlName="name"
      />
      <mat-error *ngIf="detailForm.controls['name'].errors?.['required']">
        {{ "error.required" | translate }}
      </mat-error>
    </mat-form-field>
    </div>

  </div>
  <mat-accordion multi>

    <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "load-chainage.header-berm-spring" | translate }}
        </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-description>
     <div  fxLayout="row wrap" fxLayoutGap="40px">
      <div fxLayout="column" *ngIf="columnsVisible.get('bermHeightTarget')">
        <mat-label>{{ "load-chainage.berm-height-target" | translate }}</mat-label>
        <ng-container *ngFor="let i of [].constructor(22); let idx = index">
          <app-list-input class="row"  [items]="this.bermHeights" [currentIndex]="idx" [value]="this.bermHeights[idx]" [step]="countDecimalPlaces(this.bermHeights[idx])"
           [disabled]="true" [editable]="true" (rowChange)="this.changeBermHeight($event)"
           [itemsPrefix]="this.itemsPrefix"></app-list-input>
        </ng-container>
      </div>

      <div fxLayout="column" *ngIf="columnsVisible.get('baseSpring')">
        <mat-label>{{ "load-chainage.base-spring" | translate }}</mat-label>

        <ng-container *ngFor="let i of [].constructor(22); let idx = index">
          <app-list-input class="row"  [items]="this.baseSprings" [currentIndex]="idx" [value]="this.baseSprings[idx]"  [step]="countDecimalPlaces(this.baseSprings[idx])"
           [disabled]="true" [editable]="true" (rowChange)="this.changeBaseSpring($event)"
           [itemsPrefix]="this.itemsPrefix"></app-list-input>
        </ng-container>
        </div>
        </div>

    </mat-panel-description>
  </mat-expansion-panel>

    <mat-expansion-panel *ngIf="this.id !== 'new' && !this.copy" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'log-messages.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <mat-panel-description>
      <app-log-messages-list [ngStyle]="{
        'width.pc': 100
      }" [modelId]="this.id"></app-log-messages-list>
      </mat-panel-description>
    </mat-expansion-panel>
  </mat-accordion>
</form>